import { FC } from 'react';
import { Box, Typography, Container, Grid2 as Grid } from '@mui/material';

import { useChat } from '@carcareers/contexts';
import { ChatRoomList, MessageList, SendMessage, ChatHeader } from '@carcareers/components';

export const JobseekerChat: FC = () => {
  const { selectedRoom } = useChat();

  return (
    <Container
      maxWidth="lg"
      disableGutters
      sx={{
        height: { xs: 'calc(100vh - 168px)', md: 'calc(100vh - 132px)' },
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        width: '100%',
        maxWidth: '100% !important',
        p: 0,
        m: 0,
        borderBottom: '1px solid #e0e0e0',
      }}
    >
      <Box
        sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', borderTop: '1px solid #e0e0e0' }}
      >
        <Grid container sx={{ height: '100%', flexWrap: 'nowrap', flex: 1 }}>
          <Grid
            sx={{
              display: { xs: selectedRoom ? 'none' : 'flex', md: 'flex' },
              height: '100%',
              borderRight: '1px solid #e0e0e0',
              minWidth: { xs: '100%', md: '320px' },
              maxWidth: { md: '400px' },
              flexShrink: { xs: 0, md: 1 },
              flexDirection: 'column',
            }}
          >
            <ChatRoomList />
          </Grid>
          <Grid
            sx={{
              display: { xs: selectedRoom ? 'flex' : 'none', md: 'flex' },
              height: '100%',
              position: 'relative',
              flexGrow: 1,
              overflow: 'hidden',
              flexDirection: 'column',
              minWidth: 0,
            }}
          >
            {selectedRoom ? (
              <>
                <ChatHeader />
                <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex' }}>
                  <MessageList />
                </Box>
                <SendMessage />
              </>
            ) : (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%',
                }}
              >
                <Typography variant="h4" color="text.secondary">
                  Select a conversation to start chatting
                </Typography>
              </Box>
            )}
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};
